var babelHelpers = require('./babel-helpers.js');
/**
 * MUI React helpers
 * @module react/_helpers
 */

'use strict';

var controlledMessage = 'You provided a `value` prop to a form field ' + 'without an `OnChange` handler. Please see React documentation on ' + 'controlled components';

/** Module export */
module.exports = { controlledMessage: controlledMessage };


//////////////////
// WEBPACK FOOTER
// ./node_modules/muicss/lib/react/_helpers.js
// module id = 115
// module chunks = 0